import dayjs from 'dayjs'
import { filter, isNumber } from 'lodash'
import PropTypes from 'prop-types'
import MedStockLineChart from '../../components/MedStockLineChart'

/**
 * One point per counted stock level. A count that differs from the expected stock also gets
 * a point at the expected level, at the same time and just before it, so the line drops (or
 * rises) to the count.
 */
export const logsToMedStockPoints = (logs, showExpectedStock) =>
  filter(logs, { deleted: false })
    .flatMap((log) => {
      const hasActualStock = isNumber(log.amount1)
      const hasExpectedStock = isNumber(log.amount2)
      const hasStockChanged =
        hasActualStock && hasExpectedStock && log.amount1 !== log.amount2
      const common = {
        counted: hasActualStock ? log.amount1 : undefined,
        expected: hasExpectedStock ? log.amount2 : undefined,
        notes: log.description || '',
        recordedBy: [log.loggedBy?.name?.first, log.loggedBy?.name?.last]
          .filter(Boolean)
          .join(' '),
        time: dayjs(log.timeLogged).valueOf(),
        title: log.title
      }
      const points = []
      if (hasExpectedStock && log.amount1 !== log.amount2) {
        points.push({ ...common, stock: log.amount2 })
      }
      if (hasActualStock) {
        points.push({
          ...common,
          countMismatch: hasStockChanged,
          marker: showExpectedStock
            ? hasStockChanged
              ? 'alert'
              : 'tick'
            : undefined,
          stock: log.amount1
        })
      }
      return points
    })
    .sort((a, b) => a.time - b.time)

const MedStockChart = ({ medication, logs, startDate, endDate, testId }) => {
  const { quantityType, stockQuantityType } = medication

  return (
    <MedStockLineChart
      endDate={dayjs(endDate)}
      points={logsToMedStockPoints(logs, quantityType === stockQuantityType)}
      startDate={dayjs(startDate)}
      stockQuantityType={stockQuantityType}
      testId={testId}
    />
  )
}

export default MedStockChart

MedStockChart.propTypes = {
  logs: PropTypes.array.isRequired,
  testId: PropTypes.string
}
